import { withFaroRouterInstrumentation } from '@grafana/faro-react';
import React, { ReactElement, ReactNode } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  NonIndexRouteObject,
  Route,
  RouterProvider,
} from 'react-router';

import { ChatInputProps } from '~/components/chat';
import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { ProtectedView } from '~/components/protected-view/ProtectedView';
import { Root } from '~/Root';
import { FeatureFlag } from '~/stores/use-flags/useFlags';
import { ServerError } from '~/views/error';
import { NotFound } from '~/views/error/not-found/NotFound';

import { appPaths } from './app-paths';
import {
  authRoutes,
  basicOrLightOnlyRoutes,
  commonRoutes,
  featureRoutes,
  nonBasicOrLightRoutes,
  nonBasicRoutes,
  routes,
} from './AppRoutes';

export type AppRoute = Omit<NonIndexRouteObject, 'element'> & {
  element: ReactElement<{
    renderChatInput: (props?: ChatInputProps) => ReactNode;
  }>;
  featureFlag?: FeatureFlag;
  crumb?: { isSidebar?: boolean; labelKey?: string; getLabel?: any };
  authRequired?: boolean;
};

export const Routes = () => {
  const appRoutes = [
    ...commonRoutes,
    ...featureRoutes,
    ...routes,
    ...authRoutes,
    ...nonBasicRoutes,
    ...nonBasicOrLightRoutes,
    ...basicOrLightOnlyRoutes,
  ];

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/"
        element={
          <ErrorBoundaryWrapper fallback={<ServerError />}>
            <Root />
          </ErrorBoundaryWrapper>
        }
      >
        {appRoutes.map(routeConfig => (
          <Route
            path={routeConfig.path}
            element={<ProtectedView config={routeConfig} />}
            key={routeConfig.path}
          />
        ))}
        <Route path={appPaths.notFound} element={<NotFound />} />
      </Route>
    )
  );

  const browserRouter = withFaroRouterInstrumentation(router);

  return <RouterProvider router={browserRouter} />;
};
